/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input} from '@angular/core';
import {ADMIN_RESOURCE_PAGE_IMPORTS} from '../controller/admin-resource-page-imports';

@Component({
  standalone: true,
  imports: ADMIN_RESOURCE_PAGE_IMPORTS,
  selector: 'adn-two-panel-layout',
  template: `
    <div class="row">
      <section class="col-sm-6" *ngIf="!full">
        <ng-content select="[leftPanel]"></ng-content>
      </section>
      <section class="col-sm-8 col-sm-offset-2" *ngIf="full">
        <ng-content select="[leftPanelPartA]"></ng-content>
      </section>
      <section class="col-sm-6" *ngIf="!full">
        <ng-content select="[rightPanel]"></ng-content>
      </section>
    </div>
  `
})
export class TwoPanelLayoutComponent {
  @Input() full = false;
}
